/* eslint-disable linebreak-style */
import $ from 'jquery';

/* validation return true/false
* validation auto hide and show error message, empty/invalid/gmail-typo
* validation only work with form wrapped with .EditingFormValueCell and have .EditingFormErrorLabel.empty|invalid message as child
* callbackBefore optional will execute before any validaton, mostly use to clean form message
* callbackAfter optional will execute before exist with validation result, true/false
* to use it just call the function and pass the jQuery element var; ie: isValidDropdown($('#dropdown'), [params])
*/

// helper: check existing element and hide error
const notExist = $el => {
    // return true indicate it not exist
    if (typeof ($el) === 'undefined' || $el.length === 0) {
        return true;
    }

    // hide error and return false indicate it exist
    const $container = $el.closest('.EditingFormValueCell');
    if ($container.length > 0) {
        $container.removeClass('js-error empty invalid gmail-typo');
    }

    return false;
};

// helper: run callback if defined
const runCallback = (callback, param) => {
    if (callback !== undefined) {
        callback(param);
    }

    return param;
};

// helper: show error message
const showMessage = ($el, type, callback) => {
    $el.closest('.EditingFormValueCell').addClass(`js-error ${type}`);
    runCallback(callback, false);
};

// helper: validate text field is filled
export const isFilledText = ($el, callback) => {
    if (notExist($el)) return true;
    // show error on empty
    if ($el.val() === '') {
        showMessage($el, 'empty', callback);
        return false;
    }

    // return true
    return runCallback(callback, true);
};

// helper: validate text format with regex
const isValidTextFormat = ($el, callback, regex, customCheck) => {
    if (notExist($el)) return true;

    // if fail as text
    if (!isFilledText($el, callback)) return false;

    // if pass as text, test specific format
    let pass = regex.test(String($el.val()).toLowerCase());
    if (customCheck !== undefined) pass = customCheck;
    if (!pass) {
        showMessage($el, 'invalid', callback);
        return false;
    }

    // return true
    return runCallback(callback, true);
};

// dropdown single selection; isValidDropdown($('#select'), [array valid list value], callback)
export const isValidDropdown = ($el, list, callback) => {
    if (notExist($el)) return true;

    // show error on empty
    if ($el.val() === '') {
        showMessage($el, 'empty', callback);
        return false;
    }

    // show error on invalid
    if (list !== undefined && list !== null) {
        if (list.indexOf($el.val()) < 0) {
            showMessage($el, 'invalid', callback);
            return false;
        }
    }

    // return true
    return runCallback(callback, true);
};

// Check if credit card name field has >=14 digits
export const isValidCreditCardName = (el, callback) => {
    if (notExist(el)) return true;

    // if name field is empty, return false
    if (!isFilledText(el, callback)) return false;

    // if name has 14 or more digits, return false
    if (/(\D*\s\d{14,})|((\D*\d{14,}))|([0-9 ]{14,})/.test(String(el.val()).toLowerCase())) {
        showMessage(el, 'invalid', callback);
        return false;
    }

    // otherwise return true
    return runCallback(callback, true);
};

// Check if acount name field has >=14 digits or special characters
export const isValidAccountName = (el, callback) => {
    if (notExist(el)) return true;

    // if name field is empty, return false
    if (!isFilledText(el, callback)) return false;

    // prevents user accidentally adding in credit card number
    if (/(\D*\s\d{14,})|((\D*\d{14,}))|([0-9 ]{14,})/.test(String(el.val()).toLowerCase())) {
        showMessage(el, 'invalid', callback);
        return false;
    }

    // prevents any use case with 3 digits hyphen 3 digits, e.g. 123-456, no accidental credit card details
    if (/^(.*\d{3}[-|\s]\d{3}).*$/.test(String(el.val()).toLowerCase())) {
        showMessage(el, 'invalid', callback);
        return false;
    }

    // otherwise return true
    return runCallback(callback, true);
};

// text; isValidText($('#inputElement', callback))
export const isValidText = ($el, callback) => isFilledText($el, callback);

/* email; isValidEmail($('#inputElement', callback))
* using text validation width additional format validation
*/
export const isValidEmail = ($el, callback) => {
    const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (isValidTextFormat($el, callback, regex)) {
        // check gmail typo, for example "gmial".
        const emailRegex = /^(gmial.com)|(gmial.co)|(gmial.con)|(gmial.cm)|(gmail.con)|(gmail.cm)$/;
        const emailAddr = String($el.val()).toLowerCase();
        if (emailRegex.test(emailAddr)) {
            showMessage($el, 'gmail-typo', callback);
            return false;
        }
        return true;
    }

    return false;
};

/* phone; isValidPhone($('#inputElement', callback))
* using text validation width additional format validation
* format following https://en.wikipedia.org/wiki/Telephone_numbers_in_Australia
* regex tested on https://regex101.com/r/PzhjuT/3
*/
export const isValidPhone = ($el, callback) => {
    const regex = /(^\({0,1}((0|\+61)(2|4|3|7|8)){0,1}\){0,1}(\s|-){0,1}[0-9]{2}(\s|-){0,1}[0-9]{2}(\s|-){0,1}[0-9]{1}(\s|-){0,1}[0-9]{3}$)/;
    return isValidTextFormat($el, callback, regex);
};

/* postcode; isValidPostcode($('#inputElement', callback))
* using text validation width additional format validation
* format following
* - ACT: 0200-0299 and 2600-2639.
* - NSW: 1000-1999, 2000-2599 and 2640-2914.
* - NT: 0900-0999 and 0800-0899.
* - QLD: 9000-9999 and 4000-4999.
* - SA: 5000-5999.
* - TAS: 7800-7999 and 7000-7499.
* - VIC: 8000-8999 and 3000-3999.
* - WA: 6800-6999 and 6000-6799
*/
export const isValidPostcode = ($el, callback) => {
    const regex = /^(0[289][0-9]{2})|([1345689][0-9]{3})|(2[0-8][0-9]{2})|(290[0-9])|(291[0-4])|(7[0-4][0-9]{2})|(7[8-9][0-9]{2})$/;
    return isValidTextFormat($el, callback, /$/, String($el.val()).toLowerCase().replace(regex, '') === '');
};

// number: number only, any number, any digit
export const isValidNumber = ($el, callback) => {
    const regex = /^\d+$/;
    const minLength = $el.attr('minlength');
    const min = minLength * 1;
    const val = $el.val() * 1;
    let customCheck = true;

    if (min && min > 0 && val < min) {
        customCheck = false;
    }

    return isValidTextFormat($el, callback, regex, customCheck);
};

// cc number: credit card number
// need window.cardTypes set By BED inline on page
export const isValidCcNumber = ($el, callback) => {
    const ccValidation = ccNum => {
        const visaRegEx = /^(?:4[0-9]{3})\s?([\d]{4})\s?([\d]{4})\s?([\d]{4})$/;
        const mastercardRegEx = /^(?:5[0-5])(?:[\d]{2})\s?([\d]{4})\s?([\d]{4})\s?([\d]{4})$/;
        const amexpRegEx = /^(?:3[47])(?:[\d]{2})\s?([\d]{6})\s?([\d]{5})$/;
        // const dinerRegEx = /^(?:3[0689])(?:[\d]{2})\s?([\d]{6})\s?([\d]{4})\s?([\d]{2})$/;
        // const dinerIntRegEx = /^(?:3[0689])(?:[\d]{2})\s?([\d]{6})\s?([\d]{4})\s?$/;
        // const dinerCarteRegEx = /^(?:3[0])(?:[0-5])(?:[\d]{1})\s?([\d]{6})\s?([\d]{4})\s?$/;
        // const dinerUSCANRegEx = /^(?:5[45])(?:[\d]{2})\s?([\d]{6})\s?([\d]{4})\s?([\d]{2})$/;
        let isValid = false;

        let cardTypes;

        if (document.getElementsByClassName('js-reduced-fields').length || document.getElementsByClassName('js-cc-auto-detect').length) {
            cardTypes = $('.hidden-cc-type').val();
        } else { cardTypes = $('.cc-type select').find(':selected').val(); }

        switch (cardTypes) {
            case window.cardTypes.Visa:
                if (visaRegEx.test(ccNum)) isValid = true;
                break;
            case window.cardTypes.MasterCard:
                if (mastercardRegEx.test(ccNum)) isValid = true;
                break;
            case window.cardTypes.Amex:
                if (amexpRegEx.test(ccNum)) isValid = true;
                break;
            // case window.cardTypes.Diners:
            //     if (dinerRegEx.test(ccNum) || dinerIntRegEx.test(ccNum) || dinerCarteRegEx.test(ccNum) || dinerUSCANRegEx.test(ccNum)) {
            //         isValid = true;
            //     }
            //     break;
            default:
                isValid = false;
                break;
        }

        return isValid;
    };

    return isValidTextFormat($el, callback, /$/, ccValidation($el.val()));
};

// Date should be within (current month/current year() - (12/current year + 10) range
export const isValidExpiryDate = ($el, callback) => {
    if (!isFilledText($el, callback)) return false; // empty message if the field is empty

    const month = document.getElementsByClassName('hidden-cc-expiry-month').item(0).value;
    const year = document.getElementsByClassName('hidden-cc-expiry-year').item(0).value;
    const d = new Date();
    const currentMonth = d.getMonth() + 1; // 0 = Jan
    const currentYear = Number(d.getFullYear().toString().substring(2, 4));// substring(2, 4) gives the last two digits of the current year

    if (/^\d+$/.test(month) && /^\d+$/.test(year)) {
        if ((year === '' || month === '') || (year < currentYear || year > currentYear + 10 || month < 1 || month > 12) || (month < currentMonth && year <= currentYear)) {
            showMessage($el, 'invalid', callback);
            return false;
        }
        // if passed, return true
        return runCallback(callback, true);
    }
    showMessage($el, 'invalid', callback);
    return false;
};

// vcv: 3-4 digit number
export const isValidCvc = ($el, callback) => {
    const regex = /^[0-9]{3,4}$/;
    return isValidTextFormat($el, callback, regex);
};

// bsb: 2 by 3 digit number
export const isValidBsb = ($el, callback) => {
    const regex = /^\d{3}-?\d{3}$/;
    return isValidTextFormat($el, callback, regex);
};

// checkbox
export const isValidCheckbox = ($el, callback) => {
    if (notExist($el)) return true;

    // check checkbox
    if (!$el.is(':checked')) {
        showMessage($el, 'empty', callback);
        return false;
    }

    // return true
    return runCallback(callback, true);
};



// WEBPACK FOOTER //
// ./src/components/form-elements/validation.js